import React from "react";
import '../auth.css';
import '../card.css';
import axios from 'axios';
import {reactLocalStorage} from 'reactjs-localstorage';
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBCard, MDBCardBody } from 'mdbreact';
import Select from "react-select";
import i18n from '../i18n';
import {connect} from 'react-redux';
import Menutest from './menu.js';
import { Accordion,Icon,Pagination} from 'semantic-ui-react';
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import { Table } from "reactstrap";
import "react-semantic-toasts/styles/react-semantic-alert.css";
import { API_BASE_URL } from "../utils/endpoints";
var countryOptions=[];
var value_options=[]
var group_data=[]
class EditGroup extends React.Component {

  componentWillMount() {
  
  var token=reactLocalStorage.get('accessToken');
  var ip=API_BASE_URL;
  var s2 = "localhost:3000";
  var apiBaseUrl;
  if(ip.includes(s2))
  {
   apiBaseUrl =API_BASE_URL + "/core/user/rest/contacts/"+reactLocalStorage.get('user_id_login')+"/findAllCategories";     
  }
  else
  {
   apiBaseUrl = API_BASE_URL+"/core/user/rest/contacts/"+reactLocalStorage.get('user_id_login')+"/findAllCategories";
  }

  var headers = {'Content-Type': 'application/json', 'token' :token }
axios.get(apiBaseUrl,{headers: headers})
   .then(res => {

     if(res.data.result.Categories !== undefined)
       {
         const dataoption=res.data.result.Categories;
         var length=res.data.result.Categories.length;
         var i;
         const newArr = [];
         for(i=0;i<length;i++)
         {
          var value_option=dataoption[i].category_name;

          newArr.push({
             label: value_option, 
             value:dataoption[i].id
         });
           
         }
         this.setState({groupName:this.state.groupName})
         countryOptions= newArr;

      }
    
    })

    var page=0;
    if(ip.includes(s2))
    {
     apiBaseUrl =API_BASE_URL + "/core/user/rest/contacts/findAllContactsInGroup/"+reactLocalStorage.get('id_user_edit_group')+"/"+page;     
    }
    else
    {
     apiBaseUrl = API_BASE_URL+"/core/user/rest/contacts/findAllContactsInGroup/"+reactLocalStorage.get('id_user_edit_group')+"/"+page;
    }



     headers = {'Content-Type': 'application/json', 'token' :token }
    axios.get(apiBaseUrl,{headers: headers})
        .then(res => {
          const persons = res.data.result.group;
          var array=[];
          if(persons !== undefined)
          {
            array.push({
              label:'',
              value:'null'
             })
             this.setState({group_id:res.data.result.group.group_id})
            this.setState({group_name:res.data.result.group.group_name})
            this.setState({total_group_contacts:res.data.result.group.total_group_contacts})
            var total=Math.ceil(res.data.result.group.total_group_contacts / 10);
            this.setState({totalpage:total})
         
            if(res.data.result.group.total_group_contacts === 0)
            {
            
            document.querySelector('.view_details_group').style = 'display:none';
            }
           this.setState({group_contact: res.data.result.group.group_contacts});
         
        
         this.setState({total_group_contacts:res.data.result.group.total_group_contacts})
     
         const newArr=[]
         if(res.data.result.group.category !== null)
         { newArr.push({
           label: res.data.result.group.category.category_name, 
           value:res.data.result.group.category.category_id
       });
       if(res.data.result.group.category.category_name !== '') 
       {
         this.setState({name_category:res.data.result.group.category.category_name})

       }
       else{
          this.setState({name_category:'Select ...'})
       }
       value_options= newArr;
       this.setState({group_datas : res.data.result.group.category.category_id});
       group_data = res.data.result.group.category.category_id
         }
        
       
       this.setState({groupName:this.state.groupName})
 
          }
        }) 
 }
 searchchangepage=()=>{
  var id=reactLocalStorage.get('id_user_edit_group');
  var token=reactLocalStorage.get('accessToken');
  var ip=API_BASE_URL;
  var s2 = "localhost:3000";
  var apiBaseUrl;
  var page=this.state.activePage -1;
  if(ip.includes(s2))
  {
   apiBaseUrl =API_BASE_URL + "/core/user/rest/contacts/findAllContactsInGroup/"+reactLocalStorage.get('id_user_edit_group')+"/"+page;     
  }
  else
  {
   apiBaseUrl = API_BASE_URL+"/core/user/rest/contacts/findAllContactsInGroup/"+reactLocalStorage.get('id_user_edit_group')+"/"+page;
  }



  var headers = {'Content-Type': 'application/json', 'token' :token }
  axios.get(apiBaseUrl,{headers: headers})
      .then(res => {
        const persons = res.data.result.group;
        var array=[];
        var i;
        if(persons !== undefined)
        {
          array.push({
            label:'',
            value:'null'
           })
           this.setState({group_id:res.data.result.group.group_id})
          this.setState({group_name:res.data.result.group.group_name})
          this.setState({total_group_contacts:res.data.result.group.total_group_contacts})
          if(res.data.result.group.total_group_contacts === 0)
          {
          
          document.querySelector('.view_details_group').style = 'display:none';
          }
         this.setState({group_contact: res.data.result.group.group_contacts});
       
      
       this.setState({total_group_contacts:res.data.result.group.total_group_contacts})
   

        }
      }) 
 }
    state = {

      groupName: '',
      selectedValues: [],
      total_group_contacts:[],
      group_name:'',
      total_group_contacts:0,
      group_contact:[],
      group_id:'',
      totalpage:'1',
      activePage: 1,
      group_datas:'',
      name_category:''
    };

    back=()=>
    {
      window.location="Group";
    }
  componentDidMount(){
 

         var lang=i18n.language;
         if(lang ==="ar")
         {
           document.querySelector('.title_edit_group').style = 'text-align:right;';       
       
         
         }
  }

     handleChange = event => {
       this.setState({ group_name: event.target.value});
 
     }
 
     onChange(values) {

      this.setState({
        selectedValues: values
      });
    }
    handleClick = (e, titleProps) => {
      const { index } = titleProps
      const { activeIndex } = this.state
      const newIndex = activeIndex === index ? -1 : index
   
      this.setState({ activeIndex: newIndex })
    }
    
     handleSubmit = event => {
        event.preventDefault();
        var id_user=this.state.id_user;
        var token=reactLocalStorage.get('accessToken');
     if(this.state.group_datas )
     {
       var user = {
          'group_name': this.state.group_name,
          'group_id':reactLocalStorage.get('id_user_edit_group'),
          'category':group_data,
        };
     }
     else {
      var user = {
        'group_name': this.state.group_name,
        'group_id':reactLocalStorage.get('id_user_edit_group'),
        'category':'null',
      };
     }
        var data=user;

        var ip=API_BASE_URL;
        var s2 = "localhost:3000";
        var apiBaseUrl;
        if(ip.includes(s2))
        {
          apiBaseUrl =API_BASE_URL + "/core/user/rest/contacts/updateGroup";     
        }
        else
        {
         apiBaseUrl = API_BASE_URL+"/core/user/rest/contacts/updateGroup";
        }


        var headers = {
         'Content-Type': 'application/json',
          'token' :token
          }
        axios.post(apiBaseUrl,data,{headers: headers}).then(function (response)
        {
    
        if(response.status === 200)
        {
     
           window.location="Group";
        
    
        }
        else if(response.status === 204){
          toast({
            type: 'error',
            title: i18n.t('error.label'),
            description:i18n.t('Something_wrong.label'),
            animation: 'bounce',
            time: 5000,

        });
    
        }
        
        })
        .catch(function (error) {
        console.log(error);
        toast({
          type: 'error',
          title: i18n.t('error.label'),
          description:i18n.t('Something_wrong.label'),
          animation: 'bounce',
          time: 5000,

      });
        });
      }
      handlePaginationChange = (e, { activePage }) => {this.setState({ activePage })
      var id=reactLocalStorage.get('id_user_edit_group');
  var token=reactLocalStorage.get('accessToken');
  var ip=API_BASE_URL;
  var s2 = "localhost:3000";
  var apiBaseUrl;
  var page=activePage -1;
  if(ip.includes(s2))
  {
   apiBaseUrl =API_BASE_URL + "/core/user/rest/contacts/findAllContactsInGroup/"+reactLocalStorage.get('id_user_edit_group')+"/"+page;     
  }
  else
  {
   apiBaseUrl = API_BASE_URL+"/core/user/rest/contacts/findAllContactsInGroup/"+reactLocalStorage.get('id_user_edit_group')+"/"+page;
  }



  var headers = {'Content-Type': 'application/json', 'token' :token }
  axios.get(apiBaseUrl,{headers: headers})
      .then(res => {
        const persons = res.data.result.group;
        var array=[];
        var i;
        if(persons !== undefined)
        {
          array.push({
            label:'',
            value:'null'
           })
           this.setState({group_id:res.data.result.group.group_id})
          this.setState({group_name:res.data.result.group.group_name})
          this.setState({total_group_contacts:res.data.result.group.total_group_contacts})
          if(res.data.result.group.total_group_contacts === 0)
          {
          
          document.querySelector('.view_details_group').style = 'display:none';
          }
         this.setState({group_contact: res.data.result.group.group_contacts});
       
      
       this.setState({total_group_contacts:res.data.result.group.total_group_contacts})
   

        }
      }) }


      onChangegroup =event=>{
        group_data='';
        group_data=event.value
        this.setState({group_datas : event.value})
      }
render(){
  const { activeIndex } = this.state
  const { activePage } = this.state
    return(
      <div className="big_div">
      <Menutest/>
      <div className="actionMenu">
        <div>
                          <div className="add_form" style={{ paddingBottom: '2%'}}> 
                    <MDBContainer>
                    <MDBRow>
                        <MDBCol md="6">
                        <MDBCard className="add_card">
                            <MDBCardBody>
                            <form onSubmit={this.handleSubmit} className="title_edit_group">
                                <p className="h4 text-center py-4 text_style">{i18n.t('Edit_Group.label')}</p>
                                <label
                                htmlFor="defaultFormCardNameEx"
                                className="grey-text font-weight-light"
                                >
                                {i18n.t('Name_of_Group.label')}
                                </label>
                                <input
                                type="text"
                                id="defaultFormCardNameEx"
                                className="form-control"
                                required="required"
                                name="title"
                                onChange={this.handleChange}
                                defaultValue={this.state.group_name}
                                />
                                <br />

                                <label
                                htmlFor="defaultFormCardNameEx"
                                className="grey-text font-weight-light"
                                >
                              {i18n.t('total_group_contacts.label')}
                                </label>
                                <input
                                type="text"
                                id="defaultFormCardNameEx"
                                className="form-control"
                                required="required"
                                name="title"
                                disabled
                                value={this.state.total_group_contacts}
                                />
                                <br />
                               
                                <br/>
                                <Accordion style={{ float: 'left', whiteSpace:' pre'}} className="view_details_group">

<Accordion.Title active={activeIndex === this.state.group_id } index={this.state.group_id} id={this.state.group_id} onClick={this.handleClick} style={{ float: 'left', marginTop: '0%'}}>
  <Icon name='dropdown' />
  
  {i18n.t('View_groups.label')}
</Accordion.Title>
<Accordion.Content active={activeIndex === this.state.group_id} className="group_view">
<br/>
<Table bordered>
<thead>
                    <tr>
             
              <th> {i18n.t('Full_Name.label')}</th>
              <th>{i18n.t('Mobile_Number.label')}</th>
              <th>{i18n.t('createdTime.label')}</th>
              <th>{i18n.t('country.label')}</th>
              <th>{i18n.t('company.label')}</th>
              <th>{i18n.t('district.label')}</th>
              <th>{i18n.t('governerate.label')}</th>
              <th>{i18n.t('custom_filter1.label')}</th>
              <th>{i18n.t('custom_filter2.label')}</th>
              <th>{i18n.t('custom_filter3.label')}</th>
              <th>{i18n.t('custom_filter4.label')}</th>
              <th>{i18n.t('custom_filter5.label')}</th>
              <th>{i18n.t('custom_filter6.label')}</th>
              </tr>
              </thead>
              { this.state.group_contact.map(person => 
                <tbody>
              <tr>
              <th style={{whiteSpace:'pre-line'}}>{person.first_name} {person.second_name} {person.family_name}</th>
              <th style={{whiteSpace:'pre-line'}}>{person.mobile_number}</th>
              <th style={{whiteSpace:'pre-line'}}>{person.createdTime}</th>
              <th style={{whiteSpace:'pre-line'}}>{person.country}</th>
              <th style={{whiteSpace:'pre-line'}}>{person.company}</th>
              <th style={{whiteSpace:'pre-line'}}>{person.district}</th>
              <th style={{whiteSpace:'pre-line'}}>{person.governerate}</th>
              <th style={{whiteSpace:'pre-line'}}>{person.custom_filter1}</th>
              <th style={{whiteSpace:'pre-line'}}>{person.custom_filter2}</th>
              <th style={{whiteSpace:'pre-line'}}>{person.custom_filter3}</th>
              <th style={{whiteSpace:'pre-line'}}>{person.custom_filter4}</th>
              <th style={{whiteSpace:'pre-line'}}>{person.custom_filter5}</th>
              <th style={{whiteSpace:'pre-line'}}>{person.custom_filter6}</th>
              </tr>

               </tbody>
              )}
          </Table>
          <br/>
          <Pagination
            activePage={activePage}
            onPageChange={this.handlePaginationChange}
            totalPages={this.state.totalpage}
          />
           <br/>  <br/>
          </Accordion.Content>
          </Accordion>
          <br/>  <br/>  <br/>
          <label
                            htmlFor="defaultFormCardNameEx"
                            className="grey-text font-weight-light"
                        >
                        
                        {i18n.t('Category.label')}
                        </label>
                        <Select
                          placeholder={this.state.name_category}
                          fluid
                          search
                          selection
                          options={countryOptions}
                          onChange={this.onChangegroup.bind(this)}
                          defaultValue={value_options}
                          className="sender_value"
                          id="sender_select"
                         
                        />


                        <br/><br/>          

                                <div className="text-center py-4 mt-3">
                            
                                <button className="submit_btn_pink">

                                <MDBBtn color="cyan"  onClick={this.back}>
                                {i18n.t('Back.label')}
                                </MDBBtn>
                                </button>
                                <button className="submit_btn_pink">
                                    <MDBBtn color="cyan" type="submit">
                                    {i18n.t('Submit.label')}
                                    </MDBBtn>
                                    </button>

                                </div>
                            </form>
                            </MDBCardBody>
                        </MDBCard>
                        </MDBCol>
                    </MDBRow>
                    </MDBContainer>
                     <SemanticToastContainer />
                    </div>
        </div> </div> </div>
    );
}

}


const mapStateToProps = (state)=>{
  return {...state}
}
export default connect(mapStateToProps) (EditGroup);